import React, { memo} from "react";
import { SMILEY_VISIT_DETAILS } from "Constants";
import { Div, Txt } from "Components/GenericView";

const PackageTransactionItem: React.FunctionComponent<any> = (props) => {
  const { item } = props;

  const pkg = item || {};
  const tag = pkg?.tag || "";
  const isAdj = tag === "Adjustment";
  let container = "#F6F6F6";
  let text = "#BBBBBB";
  if (tag === "Charged") {
    container = "#E9F7F8";
    text = "#9ABFC1";
  } else if (tag === "Refunded") {
    container = "#E7FFEB";
    text = "#AECFB3";
  }

  return (
    <Div
      p={"13px 11px 10px 15px"}
      br={7}
      mt={5}
      className="flex justify-between wa-tr-item center pointer"
      bg="#fff"
      onClick={() =>
        window.open(SMILEY_VISIT_DETAILS + pkg.visit_id)
      }
    >
      <Div>
        <Div>
          <Txt color="#22234E" fs={14}>
            <b>{isAdj ? "Manual Adjustment" : pkg.date}</b>
            {!isAdj && ", " + pkg.time}
          </Txt>
        </Div>
        <Div color="#757588" fs={12} mt={4} h vc>
          <Txt>
            {isAdj ? "Adjustment" : "Charge"} Date:{" "}
            {isAdj ? pkg.date : pkg.charge_date}
          </Txt>
          {!isAdj && (
            <Txt color={text} bg={container} br={3} p="2px 4px" ml={2}>
              {tag}
            </Txt>
          )}
        </Div>
      </Div>
      <Div color={pkg.is_refund||pkg.duration_used[0]==='-' ? "#E01A4F" : "#21D33B"} fs={14}>
        <b>{pkg.duration_used}</b>
      </Div>
    </Div>
  );
};

export default memo(PackageTransactionItem);
